import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'outpatient-detail',
  data: function () {
    return {
      outpatient: null,
      outpatientId: null,
      utils: utils,
      searchCallbackFlag: false, // 検索結果フラグ
    }
  },
  created: function () {
    // システム管理者 または 薬剤師
    this.$store.dispatch('USER_ADMIN_PHARMACIST')
    this.search()
  },
  computed: {
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    /** 管理者 または 組織長かつ薬剤師 */
    isAdminOrPharmacistManager() {
      return this.$store.getters.userAdminOrPharmacistManager
    },
    /** 通知 */
    notify() {
      return this.$store.getters.outpatientNotify
    },
    planNotify() {
      return this.$store.getters.planNotify
    },
    outPatient () {
      return this.$store.getters.outpatient
    },
    patientexist () {
      return this.$store.getters.patientExist
    }
  },
  methods: {
    search: function () {
      this.clearOutpatient()
      var data = {}
      var self = this
      var callback = function(data){
        if (!data || data.length < 1) {
          self.goPrev()
          return
        }
        if (data !== null && data.length > 0) {
          self.outpatient = data[0]
          self.outpatientId = data[0].attributes['outpatient-id']
        }
        self.searchCallbackFlag = true
      }
      this.searchCallbackFlag = false
      this.$store.dispatch('OUTPATIENT_SEARCH_DETAIL', { outpatientId: this.$route.params.outpatientId, data: data, callback: callback })
    },
    goPatientList: function () {
      this.$router.push({ path: '/patients/list', query: { type: this.$router.currentRoute.query.type } })
    },
    goOutpatientList: function () {
      this.$router.push({ path: '/outpatients/list', query: { type: this.$router.currentRoute.query.type } })
    },
    goPrev: function () {
      this.$router.push({ path: '/outpatients/list', query: { type: this.$router.currentRoute.query.type } })
    },
    goOutpatientEdit: function (){
      this.$router.push({ path: '/outpatients/edit/' + this.$route.params.outpatientId, query: { type: this.$router.currentRoute.query.type } })
    },
    /** 計画書作成 */
    goPlansCreate: function() {
      if (!this.patientexist) {
        this.$router.push({ path: '/plans/create/' + this.$route.params.outpatientId, query: {from: 'outpatient'} })
      }
    },
    clearOutpatient: function () {
      this.outpatient = null
      this.outpatientId = null
      this.$store.dispatch('OUTPATIENT_DETAIL_CLEAR')
    },
    goDelete: function () {
      var data = {}
      var self = this
      var callback = function () {
        self.search()
      }
      this.$store.dispatch('OUTPATIENT_DELETE', { outpatientId: this.outpatientId, data: data, callback: callback})
    },
    searchPatientCode: function() {
      var data = {
        'shop_id': this.outPatient.attributes['shop-id'],
        'patient_code': this.outPatient.attributes['patient-code']
      }
      this.$store.dispatch('OUTPATIENT_SEARCH_PATIENT_CODE', {data: data, callback: this.goPlansCreate})
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/outpatient-detail.js